import { render, staticRenderFns } from "./tagsDefault.vue?vue&type=template&id=5f06a600&scoped=true"
import script from "./tagsDefault.vue?vue&type=script&lang=js"
export * from "./tagsDefault.vue?vue&type=script&lang=js"
import style0 from "./tagsDefault.vue?vue&type=style&index=0&id=5f06a600&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f06a600",
  null
  
)

export default component.exports